export enum AppText {
  APP_DISAPLY_NAME = 'TRYSTATE.FM'
}

export enum NavbarText {
  TITLE = AppText.APP_DISAPLY_NAME,
  LOGIN_BUTTON = 'Login',
  LOGOUT_BUTTON = 'Logout',
  REGISTER_BUTTON = 'Register',
  STUDIO_SEARCH_PLACEHOLDER = 'Search by location...',
}
